import type { DeviceName } from '@ingenico/react-ui';
import type { EnumScreenLockingStatus } from '../../domain/models/deviceInfo.model';

export type LogicalDeviceSummaryCardConnectivity = Partial<
  Record<
    'bluetooth' | 'ethernet' | 'mobileNetwork' | 'SIM' | 'SSID',
    {
      readonly status: 'active' | 'inactive';
      readonly name: string;
      readonly tooltip: string;
      readonly strength?: 'EXCELLENT' | 'GOOD' | 'POOR' | undefined;
      readonly type?: string;
    }
  >
>;

export type LogicalDeviceSummaryHardware = Record<
  'battery' | 'CPU' | 'flash' | 'RAM',
  { readonly value: number; readonly inverse?: boolean }
>;

export enum LogicalDeviceConnectivityStatus {
  Online = 'Online',
  Offline = 'Offline',
}

export enum ScreenLockingStatus {
  LOCKING = 'LOCKING',
  LOCKED = 'LOCKED',
  UNLOCKING = 'UNLOCKING',
  UNLOCKED = 'UNLOCKED',
}

export interface LogicalDeviceSummaryGeneral {
  readonly name: string;
  readonly manufacturer: string;
  readonly family?: string;
  readonly model: DeviceName;
  readonly serialNumber: string;
  readonly partNumber: string;
  readonly lastSyncDate?: string;
  readonly connectivityStatus?: LogicalDeviceConnectivityStatus;
  readonly isConnected?: boolean;
  readonly storeName?: string;
  readonly reference?: string;
  readonly isScreenLocked?: boolean;
  readonly screenLockingStatus?: EnumScreenLockingStatus;
}

export type HideInfo = 'connectivityStatus' | 'family' | 'manufacturer';

export interface LogicalDeviceSummaryCardProps {
  readonly general: LogicalDeviceSummaryGeneral;
  readonly hardware?: Partial<LogicalDeviceSummaryHardware>;
  readonly connectivity?: Partial<LogicalDeviceSummaryCardConnectivity>;
  readonly onClickRefresh?: () => void;
  readonly isLoadingRefreshButton?: boolean;
  readonly componentsClassNames?: Partial<
    Record<
      | 'card'
      | 'connectivityContainer'
      | 'connectivityDivider'
      | 'connectivityItem'
      | 'divider'
      | 'hardwareChartsContainer'
      | 'hardwareChartsItemContainer'
      | 'hardwareContainer'
      | 'hardwareInfoSectionContainer'
      | 'image'
      | 'imageContainer'
      | 'isScreenLockedChipContainer'
      | 'screenLockedChipContainer'
      | 'statusChipContainer',
      string
    >
  >;
  readonly hideInfo?: HideInfo[];
  readonly displayEmptyAsDash?: boolean;
  readonly hiddenConnectivity?: (keyof LogicalDeviceSummaryCardConnectivity)[];
  readonly hideConnectivityStatusChip?: boolean;
  readonly image?: DeviceName;
  readonly screenLockingStatus?: EnumScreenLockingStatus;
}
